import 'angular-ui-bootstrap'

let deleteBoard = function() {
    angular.module('lobby')
		.controller('DeleteBoardModalController', [
			'$scope',
			'$uibModalInstance',
            'boardName',
            'Notification',
			function(
				$scope,
				$uibModalInstance,
                boardName
			) {
			var self = this;

      $scope.boardName = boardName;

      $scope.abort = function(){
        $uibModalInstance.dismiss();
      };

      $scope.done = function(){
        $uibModalInstance.close($scope.password);
      };
    }]);
};

export default deleteBoard;
